import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import LoadingPage from '@/components/shared/LoadingPage';

type LoginCallbackErrorProps = {
  error: Error;
};

/**
 * Error handler to prevent bad UX due to issues with the history object during auth
 * (back button, etc.).
 * https://github.com/okta/okta-react/issues/260#event-9794247288
 */
function LoginCallbackErrorHandler({ error }: LoginCallbackErrorProps) {
  const navigate = useNavigate();
  const isPkceError = error.message?.includes('PKCE') || error.message?.includes('codeVerifier');

  useEffect(() => {
    if (isPkceError) {
      navigate('/', { replace: true });
    }
  }, [isPkceError, navigate]);

  if (isPkceError) {
    return <LoadingPage message='Redirecting...' />;
  }

  return (
    <div>
      <p>Login error: {error.message}</p>
      <button onClick={() => navigate('/', { replace: true })}>Return to Home</button>
    </div>
  );
}

export default LoginCallbackErrorHandler;
